import { render, staticRenderFns } from "./AppPreviewDetails.vue?vue&type=template&id=6230cdab&scoped=true"
import script from "./AppPreviewDetails.vue?vue&type=script&lang=js"
export * from "./AppPreviewDetails.vue?vue&type=script&lang=js"
import style0 from "./AppPreviewDetails.vue?vue&type=style&index=0&id=6230cdab&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230cdab",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QIcon,QBtn});qInstall(component, 'directives', {ClosePopup});
